import React from "react";
import { Link } from "gatsby";

export const AboutHero = ({
  heading,
  paragraph_1,
  paragraph_2,
  title,
  mission_text,
  pillars = [],
  ctaText,
  ctaLink,
}) => {
  return (
    <header id="about-hero" className="hero hero-about pb-0 bg-light">
      <div className="position-relative container-fluid">
        <div className="row contained-xl py-md-5">
          <div className="col-md-10 offset-md-1 col-lg-6 text-center text-lg-left">
            <h1 className="display-4 mb-3">{heading}</h1>
            <p className="lead mb-3">{paragraph_1}</p>
            <p className="lead mb-4">{paragraph_2}</p>

            <h2 className="text-uppercase text-secondary h5 mt-4">
              {title}
            </h2>
            <p className="mb-4">{title}</p>

            <div className="row">
              {pillars.map((pillar, i) => (
                <div key={i} className="col-md-4 mb-3">
                  <h4 className="h6 font-weight-bold">{pillar.title}</h4>
                  <p>{pillar.text}</p>
                </div>
              ))}
            </div>

            {ctaLink && (
              <Link to={ctaLink} className="btn btn-danger btn-lg mt-4">
                {ctaText}
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default AboutHero;
